// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import './index.css';
import './styles/variables.css'; 
import './styles/App.css';      
import App from './App';
import reportWebVitals from './reportWebVitals';

// 1. Import the injectContentsquareScript function
import { injectContentsquareScript } from '@contentsquare/tag-sdk';

// 2. Inject the script *before* creating the root or right after imports
injectContentsquareScript({
  siteId: '5269382',  // Replace with your real site ID
  async: true,        // Load script asynchronously
  defer: false        // Set to true if you'd like the script to defer until DOM is parsed
});

// Standard React 18 root creation
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Optional: measure performance
reportWebVitals();
